import { buildBillingAndShippingPairFormSchema } from '../address/create-pair-form.js';
import { CustomerAddressType } from './rules.js';
export const customerAddressPairFormSchema = buildBillingAndShippingPairFormSchema(CustomerAddressType, undefined, { requireFullAddress: true });
//# sourceMappingURL=create-pair-form.js.map